import Axios from 'axios';
import React, { useEffect, useState, useCallback } from 'react';
import config from '../../Config/key';
import { userRole } from '../../Config/userRole';
import { Table, Divider, Tag, Button, message } from 'antd';
import { useSelector } from 'react-redux';
// 共用コンポーネント（デザインシステム Ph.3）
// テーブル強化 PJ Ph.3 拡大: 列リサイズ + ソート + 省略
import {
  PageContainer,
  PageHeader,
  useResizableColumns,
  ellipsisColumn,
  textSorter,
} from '../../common';

function UserMgrPage(props) {
  const [Users, setUsers] = useState([]);
  // const { usr } = props;
  const usr = useSelector((state) => state.user);

  // if (!usr.userData) return null;
  // const { isAdmin } = usr.userData;

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      // console.log({ usr });
      const res = await Axios.get(config.USER_SERVER + '/manager');
      let userData = res.data;
      await userData.map((user) => {
        user.fullName = user.lastname + ' ' + user.name;
        user.roleText = userRole[user.role];
        return user;
      });
      setUsers(userData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    //if (!usr) return null;
    readDB();
    // console.log({ user });
  }, [usr]);

  const roleChangeHandler = async (userId, role, e) => {
    e.preventDefault();
    try {
      const res = await Axios.patch(`${config.USER_SERVER}/${userId}/role`, {
        role: role,
      });
      // console.log(res);
      if (res.data.success) {
        await readDB();
        message.success('権限を変更しました。');
      }
    } catch (error) {
      alert('権限変更に失敗しました。');
      console.log(error);
    }
  };

  //削除機能は使わない
  const userDeleteHandler = async (userId, e) => {
    e.preventDefault();
    try {
      // let dataToSubmit = {
      //   userId: userId,
      // };
      const res = await Axios.delete(config.USER_SERVER + '/' + userId);
      // console.log(res);
      if (res.data.success) {
        await readDB();
        message.success('ユーザを削除しました。');
      }
    } catch (error) {
      alert('ユーザ削除に失敗しました。');
      console.log(error);
    }
  };

  // テーブル強化 PJ Ph.3 拡大: <Column> → columns 配列。テキスト列はソート + 省略、権限列は既存ボタンを維持。
  const rawColumns = [
    ellipsisColumn({
      title: '名前',
      dataIndex: 'fullName',
      key: 'fullName',
      width: 160,
      sorter: textSorter('fullName'),
    }),
    ellipsisColumn({
      title: 'メール',
      dataIndex: 'email',
      key: 'email',
      width: 220,
      sorter: textSorter('email'),
    }),
    ellipsisColumn({
      title: '会社',
      dataIndex: 'company',
      key: 'company',
      width: 160,
      sorter: textSorter('company'),
    }),
    ellipsisColumn({
      title: '部署',
      dataIndex: 'department',
      key: 'department',
      width: 140,
      sorter: textSorter('department'),
    }),
    {
      title: '権限付与',
      key: 'action',
      width: 340,
      render: (text, record) => (
        <span>
          <Button
            type={record.role === 0 ? 'primary' : 'default'}
            size="small"
            onClick={(e) => roleChangeHandler(record._id, 1, e)}
            disabled={record.role === 9 ? true : false}
          >
            管理者機能停止
          </Button>
          <Divider type="vertical" />
          <Button
            type={record.role === 2 ? 'primary' : 'default'}
            size="small"
            onClick={(e) => roleChangeHandler(record._id, 2, e)}
            disabled={record.role === 9 ? true : false}
          >
            管理者
          </Button>
          <Divider type="vertical" />
          <Button
            type={record.role === 9 ? 'primary' : 'default'}
            size="small"
            onClick={(e) => roleChangeHandler(record._id, 9, e)}
            disabled={usr.userData.role !== 9 ? true : false}
          >
            最高管理者
          </Button>
        </span>
      ),
    },
  ];

  const { columns, components, scroll, wrapRef } = useResizableColumns(rawColumns);

  // return <div>User Management Page2</div>;
  return (
    // 大量テーブル（ユーザー一覧）ページのため fluid（全幅）。
    // 広幅モニターでデータ密度を確保（デザインシステム「大量テーブル」例外）。
    <PageContainer fluid style={{ marginTop: 'var(--space-6)' }}>
      <PageHeader
        title="リ・カレント管理者"
        subtitle="登録ユーザーの管理者権限を付与・変更します。"
      />
      <div ref={wrapRef}>
        <Table
          columns={columns}
          components={components}
          scroll={scroll}
          dataSource={Users}
          size="middle"
          rowKey="email"
        />
      </div>
    </PageContainer>
  );
}

export default UserMgrPage;
